
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { UserAccess, Role } from 'app/shared/models/userModel';
import { RoleAccess } from 'app/shared/models/lookUps';
import { DataService } from 'app/shared/services/dataService';
import { AuthenticationService } from 'app/shared/services/authenticationService';

import {Observable, Subject, merge} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, filter} from 'rxjs/operators';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'edit-user',
    templateUrl: './editUser.component.html',
    styleUrls: ['./editUser.component.css',
  ]
})
export class EditUserComponent implements OnInit  {
  @ViewChild('instance', {static:true}) instance: NgbTypeahead;
  
  user: UserAccess;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  roles: RoleAccess[];
  groups: string[];
  selected: string;
  added: Set<string>;
  loading: boolean = true;
  defaultString = 'Add a county to role';
  default = this.defaultString;
  selectedRole: RoleAccess;
  errorMessage: string;
  dataChanged: boolean = false;

  constructor(
    private authService:AuthenticationService,
    private dataService: DataService,
    private dialogRef: MatDialogRef<EditUserComponent>,
    @Inject(MAT_DIALOG_DATA) private data: UserAccess
  ) { }

  ngOnInit() {
    this.user = this.data;
    this.added = (this.user.Groups) ? new Set( this.user.Groups.split(', ')) : new Set();

    this.dataService.getLookUps().subscribe(s => {
      this.roles = s.Roles;
      this.groups = s.Groups[0].groups;
      this.loading = false;

      if (this.user.Roles.length > 0 ) {
        let roleId = this.user.Roles[0].RoleId;
        this.selectedRole =  this.roles.find(r => { return r.Id === roleId ; });
      }
    });
  }

  selectedItem(event: NgbTypeaheadSelectItemEvent) {
    this.added.add(event.item);
    this.user.Groups = Array.from(this.added).join(',');
    this.dataChanged = true;  
    event.preventDefault();
    this.selected = '';
  }

  selectRole = (role: RoleAccess) => {
    if(this.user.Roles[0]?.RoleId !== role.Id) {
      this.selectedRole = role;
      this.user.Roles = [new Role(this.user.Id, role.Id)];
      this.dataChanged = true;
    }
  }

  clearGroups() {
    if(this.user.Groups) {
      this.added.clear();
      this.user.Groups = '';
      this.dataChanged = true; 
    }
  }

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance?.isPopupOpen()));
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.groups
        : this.groups.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)))
    );
  }

  getGroups() {
    if (this.user && this.user.Groups) {   return this.user.Groups.split(','); }
    return [];
  }

  onCloseModal(event: any) {
    this.dialogRef.close();
  }

  save() {
    if (!this.validation() || !this.dataChanged) { return; }

    this.dialogRef.close();

    this.dataService.setUserAccess(this.user).subscribe(res => {
        if (res) {
          this.user.Roles = this.user.Roles;
          this.user.Groups = this.user.Groups;
          this.user.Status = this.user.Status;

          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: {
              msg: 'User access saved.',
              title: 'Successful'
            }
          });
          EventAggregator.publish(EventList.userUpdated, this.user); // Publish the userUpdated event
        } else {
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: { msg: 'Error: User access did not save.' }
          });
        }
    });
  }

  validation(): boolean {
    if (!this.user.Groups &&  this.user.Status === 'Active' && this.selectedRole.Name === 'User') {
        this.errorMessage = 'A non-admin user must have a county selected.  Please select a county.';
        return false;
    }
    this.errorMessage = '';
    return true;
  }

  selectStatus(status) { 
    if(this.user.Status !== status) {
      this.user.Status = status;
      this.dataChanged = true; 
    }
  }

  resendConfirmation() {
    this.authService
      .requestConfirmationEmail(this.user)
      .then(result => {
        if (result.Success) {
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: {
              title: 'Email Sent',
              msg: 'Confirmation email sent.'
            }
          });
        } else {
          let errStr = result.Errors.reduce(
            (accu, current) => accu + (current + '<br/>'),
            ''
          );
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: { msg: errStr }
          });
        }
      })
      .catch(_ => { });
  }
}